import { render, staticRenderFns } from "./TabelaProcessos.vue?vue&type=template&id=829e7302&scoped=true&"
import script from "./TabelaProcessos.vue?vue&type=script&lang=js&"
export * from "./TabelaProcessos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaProcessos.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TabelaProcessos.vue?vue&type=style&index=1&id=829e7302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829e7302",
  null
  
)

export default component.exports